var _path, _path2, _path3, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParkingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 65,
    viewBox: "0 0 54 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3127 46.8455C27.3127 46.8455 36.4601 39.985 36.4601 32.5527C36.4601 27.8166 32.3649 23.977 27.3127 23.977C22.2605 23.977 18.1653 27.8166 18.1653 32.5527C18.1653 39.985 27.3127 46.8455 27.3127 46.8455Z",
    stroke: "url(#paint0_radial_189:185)",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5975 29.6939V38.8413",
    stroke: "url(#paint1_radial_189:185)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5975 29.6939H29.0278C29.6343 29.6939 30.216 29.9348 30.6449 30.3637C31.0737 30.7926 31.3147 31.3743 31.3147 31.9808C31.3147 32.5873 31.0737 33.1689 30.6449 33.5978C30.216 34.0267 29.6343 34.2676 29.0278 34.2676H25.5975V29.6939Z",
    stroke: "url(#paint2_radial_189:185)",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.08533,
    y: 0.990662,
    width: 52.4547,
    height: 62.7759,
    rx: 4.75,
    stroke: "url(#paint3_radial_189:185)",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_189:185",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.739 45.8366) rotate(-68.6821) scale(29.6022 25.4423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_189:185",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8475 38.4378) rotate(-86.9475) scale(11.0464 1.49071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_189:185",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0268 34.0658) rotate(-58.627) scale(6.4598 7.28689)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_189:185",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.074 61.2249) rotate(-67.7929) scale(82.4166 73.1884)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D74E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02ACEC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingIcon);
export default __webpack_public_path__ + "static/media/parking_icon.1f48cab8.svg";
export { ForwardRef as ReactComponent };